import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiRouterService } from '../http/api.router';
import { BaseHttpService } from '../http/base.http.service';

@Injectable({
  providedIn: 'root'
})
export class HolidayCalendarsHttpService extends BaseHttpService {

  private baseURL = `holiday-calendars`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  private buildQuery(params: { search?: string; page?: number; size?: number }): string {
    const parts: string[] = [];
    if (params.search !== undefined && params.search !== '') parts.push(`search=${encodeURIComponent(params.search)}`);
    if (params.page !== undefined) parts.push(`page=${params.page}`);
    if (params.size !== undefined) parts.push(`size=${params.size}`);
    return parts.length > 0 ? `?${parts.join('&')}` : '';
  }

  public getHolidayCalendarsByClientId(clientId: number, search?: string, page?: number, size?: number) {
    const query = this.buildQuery({ search, page, size });
    const url = this.routerService.mount(`${this.baseURL}/client/${clientId}${query}`);
    return this.read(url);
  }

  public getHolidayCalendars(search?: string, page?: number, size?: number) {
    const query = this.buildQuery({ search, page, size });
    const url = this.routerService.mount(`${this.baseURL}${query}`);
    return this.read(url);
  }

  public getHolidayCalendar(id: number) {
    const url = this.routerService.mount(`${this.baseURL}/${id}`);
    return this.read(url);
  }

  public createHolidayCalendar(body: any) {
    const url = this.routerService.mount(this.baseURL);
    return this.create(body, url);
  }

  public updateHolidayCalendar(id: number, body: any) {
    const url = this.routerService.mount(`${this.baseURL}/${id}`);
    return this.update(body, url);
  }

  public deleteHolidayCalendar(id: number) {
    const url = this.routerService.mount(`${this.baseURL}/${id}`);
    return this.delete(url);
  }
}
